export const ObservationalStudyOptionsConstant = [
    { label: 'Case Crossover', value: 'CaseCrossover' },
    { label: 'Case Control', value: 'CaseControl' },
    { label: 'Cohort', value: 'Cohort' },
    { label: 'Cross-Sectional', value: 'Cross-sectional' },
];
